import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatBubbleCheckmarkRegular from './chat-bubble-checkmark-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ChatBubbleCheckmarkRegular {...props} />;
}
SvgComponent.iconName = 'chatBubbleCheckmarkRegular';

export const ChatBubbleCheckmarkRegularIcon = svgIconWrapper(SvgComponent);
